import { useState, useRef } from "react";

import { API_URL, getValFromLS } from "../../helpers";

import Input from "../../components/Input";
import Radios from "../../components/Radios";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

import CopyElement from "./CopyElement";

const LinksForm2 = ({ result, handleStatus }) => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		fname: result.fname,
		lname: result.lname,
		email: result.email,
		liaison: result.liaison,
	});
	const [msg, setMsg] = useState({});

	const formElement = useRef(null);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e = null, id = 0) => {
		if (e) {
			e.preventDefault();
		} else {
		}
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/admin/links2`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("sponsorId", result.sponsorId);
		data.append("organization", result.organization);
		data.append("token", getValFromLS("vtoUserToken"));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({
					type: "success",
					text: json.text,
				});
			} else if (json && json.resp === 2) {
				handleStatus({
					...result,
					status: 3,
					registrationUrl: json.registrationUrl,
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<form
			ref={formElement}
			method="post"
			action="/"
			onSubmit={(e) => handleSubmit(e)}
			className="well"
		>
			<table className="approved assigned" style={{ marginTop: "0" }}>
				<thead>
					<tr>
						<th colSpan="4" className="hdg">
							{result.organization}
						</th>
					</tr>
					<tr>
						<td style={{ width: "17%" }}>Sponsor ID</td>
						<td className="left">Status</td>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{result.sponsorId}</td>
						<td className="left">{getStatusStr(result.status)}</td>
					</tr>
				</tbody>
			</table>

			{result.dashboardUrl && <CopyElement url={result.dashboardUrl} />}

			<div className="form-group">
				<Input
					name="fname"
					label="First Name"
					reqd={true}
					value={names.fname}
					update={handleUpdate}
					errors={errors}
					note=""
				/>

				<Input
					name="lname"
					label="Last Name"
					reqd={true}
					value={names.lname}
					update={handleUpdate}
					errors={errors}
					note=""
				/>
			</div>

			<div className="form-group">
				<Input
					name="email"
					label="Email Address"
					reqd={true}
					value={names.email}
					update={handleUpdate}
					errors={errors}
					note=""
				/>
				<Input
					name="liaison"
					label="Valero Liaison Email"
					reqd={true}
					value={names.liaison}
					update={handleUpdate}
					errors={errors}
					note=""
				/>
			</div>

			<div className="form-group radios" style={{ marginTop: "15px" }}>
				<Radios
					label="Please select:"
					reqd={true}
					data={[
						{
							name: "action",
							val: "email",
							label: "Email the registration invite link to the above address",
						},
						{
							name: "action",
							val: "screen",
							label: "Output the registration link to the screen",
						},
					]}
					value={names.payment || ""}
					click={handleUpdate}
				/>
			</div>

			<div className="msg-submit" style={{ marginTop: "30px" }}>
				{msg.type && <Msg data={msg} />}

				<div className={msg.type === "working" ? "hidden" : "submit-container"}>
					<Submit
						click={() => handleStatus({ status: 10 })}
						left="Back"
						submit="Generate Registration Link"
					/>
				</div>
			</div>
		</form>
	);
};

export default LinksForm2;

function getStatusStr(status) {
	return status === 0
		? "Sponsor has not started a BFC registration."
		: status === 1
		? "Sponsor has already submitted their BFC registration."
		: "Sponsor has started their BFC registration, but not yet submitted it.";
}
